<template>
  <div class="easy-mode-style-refer">
    <div class="easy-mode-style-refer-title-box">
      <!-- <h3 class="flex1 width-0">{{ $$t("create.select_style") }}</h3> -->
      <div class="easy-mode-style-refer-tags flex1 width-0">
        <swiper
          ref="refStyleSwiper"
          slidesPerView="auto"
          :spaceBetween="createRenderType == 'pc' ? 16 : 16"
          :slidesOffsetAfter="createRenderType == 'pc' ? 16 : 16"
          @slideChange="onSlideChange"
        >
          <swiper-slide
            v-for="(item, index) in renderData.genreList"
            :key="index + 1"
          >
            <div
              class="swiper-tag-item pointer"
              :class="{
                'swiper-tag-item-active': item == currentGenre,
              }"
              @click="() => onGenreSelect(item)"
            >
              <span class="block omlh-2 tc"> {{ item }}</span>
            </div>
          </swiper-slide>
        </swiper>
      </div>
      <div class="easy-mode-style-refer-switch flex-center">
        <div
          class="easy-mode-style-refer-switch-item easy-mode-style-refer-switch-left"
        >
          <IconButton
            size="24px"
            icoSize="12px"
            backgroundColor="rgba(255, 255, 255, 0.1)"
            hoverBackgroundColor="rgba(255, 255, 255, 0.2)"
            :disabled="renderData.disabledSwichFirst"
            @onClick="changePrev"
          >
            <img src="@/assets/img/content/prev.png" alt="" />
          </IconButton>
        </div>
        <div
          class="easy-mode-style-refer-switch-item easy-mode-style-refer-switch-right"
        >
          <IconButton
            size="24px"
            icoSize="12px"
            backgroundColor="rgba(255, 255, 255, 0.1)"
            hoverBackgroundColor="rgba(255, 255, 255, 0.2)"
            :disabled="renderData.disabledSwichLast"
            @onClick="changeNext"
          >
            <img src="@/assets/img/content/next.png" alt="" />
          </IconButton>
        </div>
      </div>
    </div>
    <!-- <div class="easy-mode-style-refer-swiper-box">
      <swiper
        ref="refStyleSwiper"
        slidesPerView="auto"
        :spaceBetween="createRenderType == 'pc' ? 10 : 10"
        :slidesOffsetAfter="createRenderType == 'pc' ? 10 : 10"
        @slideChange="onSlideChange"
      >

         <swiper-slide
          :key="0"
        >
          <div class="swiper-item-style-box swiper-item-style-box-random pointer" @click="onRandomStyle">
            <div class="swiper-item-style-cover flex-center">
              <i  class="block"></i>
            </div>

            <div class="swiper-item-style-title flex-center ">
              <span class="block omlh-2 tc"> Random</span>
            </div>
          </div>
        </swiper-slide>
        <swiper-slide
          v-for="(item, index) in renderData.genreList"
          :key="index+1"
        >
          <div class="swiper-item-style-box pointer" @click="() => onGenreSelect(item)">
            <div class="swiper-item-style-cover">
              <img
                v-lazy="
                  item.cover
                    ? getObjectStorageFullUrl(item.cover)
                    : defaultCover
                "
              />
            </div>

            <div class="swiper-item-style-title flex-center">
              <span class="block omlh-2 tc"> {{item.tag}}</span>
            </div>
          </div>
        </swiper-slide>
      </swiper>
    </div> -->
  </div>
</template>

<script setup>
import {
  ref,
  defineProps,
  defineEmits,
  computed,
  readonly,
  reactive,
  watch,
  defineExpose,
  onMounted,
  onUpdated,
  onUnmounted,
} from "vue";

import { useRouter, useRoute } from "vue-router";
import { $$t, $$language } from "@/i18n/i18n.js";

import { Swiper, SwiperSlide } from "swiper/vue";
import "swiper/css";
import "swiper/css/effect-coverflow";
import IconButton from "@/components/basic/button/IconButton.vue";
import { getObjectStorageFullUrl } from "@/lib/objectStorage/objectStorage.js";
import apiReferMusic from "@/api/api/apiReferMusic.js";
import { storeToRefs } from "pinia";
import useCreateLayoutStore from "@/store/create/createLayoutStore.js";
import useCreateEasyModeStore from "@/store/create/createEasyModeStore.js";
const createLayoutStore = useCreateLayoutStore();
const createEasyModeStore = useCreateEasyModeStore();

const { createRenderType } = storeToRefs(createLayoutStore);
const { currentGenre } = storeToRefs(createEasyModeStore);

import defaultCover from "@/assets/img/default-cover-3x.png";

const Router = useRouter();
const route = useRoute();

const refStyleSwiper = ref(null);
const props = defineProps({});
const emits = defineEmits([]);

const stateData = {
  observeFirst: null,
  observeLast: null,
};

const renderData = reactive({
  swiperActiveIndex: 0,
  disabledSwichFirst: false,
  disabledSwichLast: false,
  genreList: new Array(10).fill(1),
});

const onSlideChange = (swiper) => {
  renderData.swiperActiveIndex = swiper.activeIndex;
};

const changePrev = () => {
  refStyleSwiper.value?.$el.swiper?.slideTo(renderData.swiperActiveIndex - 3);
};

const changeNext = () => {
  refStyleSwiper.value?.$el.swiper?.slideTo(renderData.swiperActiveIndex + 3);
};

const initObserverEvent = () => {
  nextTick(() => {
    if (refStyleSwiper.value?.$el) {
      setTimeout(() => {
        let els = refStyleSwiper.value?.$el.querySelectorAll(".swiper-slide");
        if (els && els.length >= 1) {
          isElementHalfVisible(els[0], "First");
          isElementHalfVisible(els[renderData.genreList.length - 1], "Last");
        }
      }, 10);
    }
  });
};

const isElementHalfVisible = (element, type) => {
  stateData[`observe${type}`] = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        renderData[`disabledSwich${type}`] = entry.isIntersecting;
      });
    },
    {
      root: null, // 默认为 viewport
      rootMargin: "0px", // 边距
      threshold: 0.5, // 0.0 到 1.0 的每个步长
    }
  );
  stateData[`observe${type}`].observe(element);
};

const onRandomStyle = () => {};

const onGenreSelect = (item) => {
  createEasyModeStore.setCurrentGenre(item);
};

const initGenreList = () => {
  return new Promise((resolve, reject) => {
    apiReferMusic
      .getEasyStyleMoods()
      .then((res) => {
        if (res.code == 200) {
          renderData.genreList =
            res.data?.genres ?? [].concat(res.data?.moods ?? []);
          resolve();
        } else {
          reject(res);
        }
      })
      .catch((err) => {
        reject(err);
      });
  });
};

const reinitObserverEvent = () => {
  stateData[`observeFirst`]?.disconnect();
  stateData[`observeLast`]?.disconnect();
  initObserverEvent();
};

onMounted(() => {
  renderData.genreList = createEasyModeStore.genres_all ?? [];
  reinitObserverEvent();
});

watch(
  () => {
    return createEasyModeStore.genres_all;
  },
  () => {
    renderData.genreList = createEasyModeStore.genres_all ?? [];
    reinitObserverEvent();
  }
);

onUnmounted(() => {
  stateData[`observeFirst`]?.disconnect();
  stateData[`observeLast`]?.disconnect();
});
</script>
<style lang="scss">
.easy-mode-style-refer {
  .easy-mode-style-refer-title-box {
    display: flex;
    align-items: start;
    justify-content: space-between;
    h3 {
      font-family: HarmonyOS Sans SC;
      font-size: 18px;
      font-weight: 500;
      line-height: 20px;
      color: #ffffff;
    }
    .easy-mode-style-refer-switch-item {
      margin-left: 8px;
    }
  }
  .easy-mode-style-refer-tags {
    height: 28px;
    .swiper {
      z-index: unset;
    }
    .swiper-tag-item {
      font-family: HarmonyOS Sans SC;
      font-size: 16px;
      font-weight: 500;
      line-height: 20px;
      text-align: center;
      letter-spacing: 0.02em;
      color: #ffffff;
      padding: 0 0 6px 0;
      border-bottom: 2px solid rgba(255, 255, 255, 0);
      opacity: 0.5;
      text-transform: capitalize;
      &:hover {
        opacity: 1;
        border-bottom: 2px solid rgba(255, 255, 255, 0);
      }

      &.swiper-tag-item-active {
        opacity: 1;
        border-bottom: 2px solid #ffffff;
      }
    }
    .swiper {
      height: 100%;
      .swiper-wrapper {
        display: flex;
        height: 100%;
      }
      .swiper-slide {
        height: 100%;
        width: max-content;
      }
    }
  }
  .easy-mode-style-refer-swiper-box {
    height: 84px;
    margin: 13px 0 0 0;
    .swiper-item-style-box {
      .swiper-item-style-cover {
        height: 58px;
        width: 58px;
        border-radius: 12px;
      }
      img {
        width: 100%;
        height: 100%;
        border-radius: 12px;
      }
      &.swiper-item-style-box-random {
        .swiper-item-style-cover {
          background: linear-gradient(139deg, #62ffcb -15%, #bc97ff 94%);
        }
        i {
          height: 24px;
          width: 24px;
          background: url("@/assets/img/dice-random-ico.png");
          background-size: 100% 100%;
        }
      }
    }
    .swiper-item-style-title {
      margin-top: 2px;
      height: 22px;
      span {
        font-family: HarmonyOS Sans SC;
        font-size: 11px;
        font-weight: normal;
        line-height: 12px;
        max-height: 100%;
        color: rgba(255, 255, 255, 0.8);
      }
    }
    .swiper {
      .swiper-wrapper {
        display: flex;
      }
      .swiper-slide {
        width: 60px;
        height: 84px;
      }
    }
  }
}
</style>
